/**
 *Created by jmmartinez on 3/9/23
 *
 **/

import React, {components} from 'react'
import PropTypes from 'prop-types';

import "../../resources/css/combobox.css";
import Select from 'react-select';
import {Button, Icon, Intent} from "@blueprintjs/core";

//Modificación del estilo por defecto:
const customStyles = {
    control: base => ({
        ...base,
        height: 32,
        minHeight: 32,
        //minWidth: '400px',
        //background: "#0f0",
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        margin: '0 0 6px 0', //Subimos el texto
        textAlign: 'left'
        //background: "#0f0",
    }),
    menuList: (provided, state) => ({
        ...provided,
        textAlign: 'left',
    }),


};
class ComboBox extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            className: props.className,
            id: props.id ? props.id : "select",
            fieldText: props.fieldText ? props.fieldText : "nombre",
            fieldLabel: props.fieldLabel ? props.fieldLabel : "codigoid",
            fieldKey: props.fieldKey ? props.fieldKey : "codigo",
            items: props.items,
            itemSelected: props.itemSelected,
            icon: props.icon,
            filterable: props.filterable,
            placeholder: props.placeholder,
            popoverClassName: props.popoverClassName,
            label: props.label,
            labelInline: props.labelInline,
        }
        //console.log("customStyles: ", customStyles);

        /*
        const { Option } = components;
        this.IconOption = props => (
            <Option {...props}>
                <img
                    src={require('./' + props.data.icon)}
                    style={{ width: 36 }}
                    alt={props.data.label}
                />
                {props.data.label}
            </Option>
        );
        */
       // console.log("ComboBox - Constructor");
       // console.log("props.items: ", props.items);
    }

    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        if( nextProps.items !== prevState.items){
            newState.items= nextProps.items;
        }

        if( nextProps.itemSelected !== prevState.itemSelected){
            newState.itemSelected= nextProps.itemSelected;
        }

        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    /*
    getDefaultValue= () => {
        const {fieldText, fieldKey,placeholder, itemSelected} = this.state;
        if (itemSelected)
            return itemSelected;
        else{
            let itemDefault= {};
            itemDefault[fieldText]= placeholder;
            itemDefault[fieldKey]= 0;
            return itemDefault;
        }
    }
     */

    getValue= () => {
        const {fieldText, fieldKey,placeholder, itemSelected} = this.state;
        //console.log(">>>> getValue <<<<<<");
        //console.log("itemSelected: " , itemSelected);
        if (itemSelected)
            return itemSelected;
        else{
            let itemDefault= {};
            itemDefault[fieldText]= placeholder;
            itemDefault[fieldKey]= 0;
            return itemDefault;
        }
    }

    getOptionLabel= (option) => {
        const {fieldText, fieldLabel} = this.state;
        //console.log("getOptionLabel: ", option);
        if (option) {
            let value = option[fieldText];
            //let value = (<div><Icon icon="user"/> {option[fieldText]} </div>);
            if (fieldLabel && option[fieldLabel])
                value = "(" + option[fieldLabel] + ") " + value;

            return value;
        }
        return "";
    }

    valueChanged= (option, info) => {
        const {onValueChanged} = this.props;
        this.setState({selectedItem: option});
        onValueChanged && onValueChanged(option);
    };

    eliminar= () => {
        const {onValueChanged} = this.props;
        this.setState({selectedItem: null});
        onValueChanged && onValueChanged(null);
    }


    render() {
        const {className, id, items, itemSelected, fieldKey, icon, filterable, placeholder, label, labelInline} = this.state;
        const {mostrarEliminar} = this.props;
        let filterableReal= filterable && Boolean(filterable);

        //console.log("ComboBox - Render");
        //console.log("id: ", id);
        //console.log("label: ", label);
        //console.log("labelInline: ", labelInline);
        //console.log("itemSelected: ", itemSelected);
        //console.log("defaultValue: ", this.getDefaultValue());
        //console.log("items: ", items);

        let classNameEnvolvente= labelInline && Boolean(labelInline) ? "combobox_envolvente_inline" : "combobox_envolvente";
        let labelStyle= labelInline && Boolean(labelInline) ? {marginRight: 10} : {marginTop: -4, marginRight: 10,  marginBottom: 1+4};

        return (
            <div className={classNameEnvolvente}>
                {label && label != "" &&
                    <div style={labelStyle}>{label}</div>
                }
                {(labelInline && Boolean(labelInline) && icon && icon != "") &&
                    <Icon icon={icon} style={{margin:4}} />
                }
                <div className={"combobox_combo"}>
                    <Select
                            styles={customStyles}
                            options={items}
                            name={id}
                            isSearchable={filterableReal }
                            //defaultValue={this.getDefaultValue()}
                            value={this.getValue()}

                            //getOptionLabel={(option) => `${option.label}: ${option.nombre}`}
                            getOptionLabel={this.getOptionLabel}
                            getOptionValue={(option) => `${option[fieldKey]}`}

                            closeMenuOnSelect={true}
                            onChange={this.valueChanged}
                            noOptionsMessage={placeholder}
                            //components={{ Option: this.IconOption }}


                    />
                </div>
                <div>
                    { (mostrarEliminar && Boolean(mostrarEliminar)) &&
                        <Button style={{marginLeft: 10, marginRight: 10}} intent={Intent.DANGER} icon="trash" onClick={this.eliminar}/>
                    }
                </div>
            </div>
        );
    }
}


ComboBox.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    fieldText: PropTypes.string,
    fieldLabel: PropTypes.string,
    fieldKey: PropTypes.string,
    items: PropTypes.array.isRequired,
    onValueChanged: PropTypes.func,
    placeholder: PropTypes.string,
    filterable: PropTypes.bool,
    itemSelected: PropTypes.object,
    icon: PropTypes.string,
    label: PropTypes.string,
    labelInline: PropTypes.bool,
    mostrarEliminar: PropTypes.bool,
}

export default ComboBox;